
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { firebaseFunctions } from '@/firebase';
import { algoliaClient } from '@/algolia';
import { debounce } from 'lodash-es';
import algoliasearch from 'algoliasearch';
import constants from '@/utils/constants';

library.add(faPencilAlt);

export class SearchableField {
  public key: string = '';
  public label: string = '';
  public sortable?: boolean = true;
  public class?: string = 'text-center text-nowrap';

  static FromObject(obj: any) {
    return Object.assign(new SearchableField(), obj);
  }
}

export interface ISearchableTable<T> {
  createItem(data: any): T;
}

// @ts-ignore
@Component()
export default abstract class SearchableTable<T> extends Vue
  implements ISearchableTable<T> {
  @Prop() collectionName!: string;
  @Prop() fieldsSet!: Array<SearchableField>;
  @Prop({ default: 'ID' })
  primaryKey!: string;
  @Prop({
    type: Boolean,
    default: true
  })
  showSearchBar!: boolean;
  @Prop() sortMapping!: Array<any>;

  abstract createItem(data: any): T;

  protected items: any[] = [];

  protected currentPage: number = 1;
  protected totalRows: number = 0;

  protected sortBy: string = 'ID';
  protected sortOrder: 'desc' | 'asc' = 'asc';

  protected perPage: number = 20;
  protected perPageOptions: Array<number> = [10, 20, 50, 100];

  protected searchKeyword: string = '';

  protected pageIsBusy: boolean = true;

  protected debouncedOnSearchStore: any;

  protected algoliaIndex: algoliasearch.Index;

  constructor(props: any) {
    super(props);

    const projectID = process.env.VUE_APP_FIREBASE_PROJECTID;
    this.algoliaIndex = algoliaClient.initIndex(
      `${projectID}_${this.collectionName}`
    );

    this.debouncedOnSearchStore = debounce(this.onSearchStore, 300);
  }

  mounted() {
    this.sortBy = this.primaryKey;

    this.perPage = this.$store.state.defaultPerPage;
    this.perPageOptions = this.$store.state.perPageOptions;
    this.updatePage();
  }

  limitPaging(page, total) {
    if (page < 6) {
      return 7;
    }
    if (page > Math.ceil(total / this.perPage) - 5) {
      return 7;
    }
    return 5;
  }

  onMaxEntriesChanged() {
    this.updatePage();
  }

  onSearchStore() {
    this.updatePage();
  }

  onPageChange(page) {
    this.currentPage = page;
    this.query();
  }

  updatePage() {
    this.reset();
    this.query();
  }

  reset() {
    this.currentPage = 1;
  }

  sortingChanged(ctx) {
    this.pageIsBusy = true;
    let selectedOrderBy = this.sortMapping
      ? this.sortMapping.find(v => v.key === ctx.sortBy).value
      : ctx.sortBy;
    firebaseFunctions
      .httpsCallable('sortAlgoliaIndex')({
        algoliaIndex: this.collectionName,
        orderBy: selectedOrderBy,
        order: ctx.sortDesc ? 'desc' : 'asc'
      })
      .then(result => {
        if (result.data.code === constants.STATUS_200_STRING) {
          this.query();
        }
        this.pageIsBusy = false;
      })
      .catch(err => {
        console.log(err);
        this.pageIsBusy = false;
      });
  }

  query() {
    this.pageIsBusy = true;
    this.algoliaIndex.clearCache();
    this.algoliaIndex
      .search({
        query: this.searchKeyword,
        typoTolerance: false,
        page: this.currentPage - 1,
        hitsPerPage: this.perPage
      })
      .then(resp => {
        this.items = resp.hits.map(v => this.createItem(v));
        this.totalRows = resp.nbHits;

        this.pageIsBusy = false;
      })
      .catch(err => {
        console.error(err);

        this.items = [];

        this.pageIsBusy = false;
      });
  }

  get sortDesc(): boolean {
    return this.sortOrder === 'desc';
  }

  set sortDesc(value) {
    this.sortOrder = value ? 'desc' : 'asc';
  }
}
